export default{
    addiction : 'Addiction',
    addictionTo : 'Addiction To',
    typesOfDrug : 'Type/Name(Alcohol،Smoke,...)',
    duration : 'Duration(Month)',
}